import React from "react";
import {
  Box,
  Stack,
} from "@mui/material";
import PolygonBox from "../../../components/questionBoxs/PolygonBox";
import RoundedBox from "../../../components/questionBoxs/RoundedBox";
import RoundBox from "../../../components/questionBoxs/RoundBox";
import useQuestionNavigatorStyle from "../testStyle/iitStyle/questionNavigatorStyle";

function InfoPanel({notVisited,notAnswered,answered,marked,markedWithAnswered,currentQuestion}) {
    const classes = useQuestionNavigatorStyle();

  return (
    <Box className={classes.infoPanel}>
      <Stack direction="row" spacing={1} flexWrap="wrap">
        <Box
          style={{
            display: "flex",
            gap: "10px",
            justifyContent: "center",
            alignItems: "center",
            margin: "0.3rem",
          }}
        >
          <RoundedBox number={isNaN(notVisited)?0:notVisited} />
          Not Visited
        </Box>
        <Box
          style={{
            display: "flex",
            gap: "10px",
            justifyContent: "center",
            alignItems: "center",
            margin: "0.3rem",
          }}
        >
          <PolygonBox number={notAnswered} />
          Not Answered
        </Box>
        <Box
          style={{
            display: "flex",
            gap: "10px",
            justifyContent: "center",
            alignItems: "center",
            margin: "0.3rem",
          }}
        >
          <PolygonBox number={answered} color={"green"} />
          Answered
        </Box>
        <Box
          style={{
            display: "flex",
            gap: "10px",
            justifyContent: "center",
            alignItems: "center",
            margin: "0.3rem",
          }}
        >
          <RoundBox number={marked} color={"green"} />
          Marked for Review
        </Box>
        <Box
          style={{
            display: "flex",
            gap: "10px",
            justifyContent: "center",
            alignItems: "center",
            margin: "0.3rem",
          }}
        >
          <RoundBox number={markedWithAnswered} color={"green"} showIcon={true} />
          Answered & Marked for Review (will be considered for evaluation){" "}
        </Box>
        {/* <Box
          style={{
            display: "flex",
            gap: "10px",
            justifyContent: "center",
            alignItems: "center",
            margin: "0.3rem",
          }}
        >
          <RoundedBox  color={'#3498db'} textColor={'white'}  number={currentQuestion+1} />
          Current Question
        </Box> */}
      </Stack>
    </Box>
  );
}

export default InfoPanel;
